// Generated by CoffeeScript 2.7.0
var ModelErrors;

import {
  translate
} from 'helpers/i18n.js';

export default ModelErrors = class ModelErrors {
  constructor(base) {
    this.base = base;
    this.messages = {};
  }

  add(attribute, message = '是无效的') {
    var base, error_message;
    error_message = (base = this.messages)[attribute] != null ? base[attribute] : base[attribute] = [];
    error_message.push(message);
    return error_message;
  }

  clear() {
    return this.messages = {};
  }

  merge(errors) {
    return _.each(errors, (error_messages, attribute) => {
      return _.each(error_messages, (error_message) => {
        return this.add(attribute, error_message);
      });
    });
  }

  isBlank() {
    return _.isBlank(this.messages);
  }

  // is Blank alias
  isEmpty() {
    return this.isBlank();
  }

  fullMessages() {
    return _.map(this.messages, (message, attribute) => {
      if (attribute === 'base') {
        return `${message}`;
      } else {
        return `${translate(attribute, {
          scope: [this.base.getI18nKey()]
        }) || ''}${message}`;
      }
    });
  }

  fullMessageFor(attribute) {
    return this.messages[attribute] || [];
  }

};
